module.exports = __webpack_public_path__ + "assets/img/7-1.10fe6af2.png";